import { usePlanningStore } from '@planning/AppProvider'
import { INonNumericReleaseItem } from '@planning/rt-stores/nnrOrder/NnrOrderItem'
import { getNonNumericReleaseStatus } from '@planning/utils/numeric-utils'
import { observer } from 'mobx-react-lite'
import { ReleaseSummary } from '../../molecules/ReleaseSummary'

type Props = {
  nonNumericReleaseItem: INonNumericReleaseItem
}

export const NonNumericReleaseSummary = observer(({ nonNumericReleaseItem }: Props) => {
  const { vesselVisitItemStore } = usePlanningStore()
  const nonNumericRelease = nonNumericReleaseItem.data

  const vesselItem =
    nonNumericRelease.carrierVisitId && nonNumericRelease.modeOfTransport === 'Vessel'
      ? vesselVisitItemStore.getById(Number(nonNumericRelease.carrierVisitId))
      : null

  const vesselNumber = vesselItem?.data?.number

  return (
    <ReleaseSummary
      carrierType={nonNumericReleaseItem.data.modeOfTransport}
      carrierName={nonNumericReleaseItem.carrierName}
      validityDate={nonNumericRelease.validityDate}
      vesselNumber={vesselNumber ?? undefined}
      status={getNonNumericReleaseStatus(nonNumericRelease)}
      containerRequirements={{
        operatorName: nonNumericRelease.shippingLine,
        archetypeName: nonNumericRelease.archetypeName,
        containerLengths: nonNumericRelease.containerLengths,
        containerHeights: nonNumericRelease.containerHeights,
        containerTypes: nonNumericRelease.containerTypes,
      }}
      amounts={{
        total: nonNumericRelease.amount,
        assigned: nonNumericRelease.assigned,
        fulfilled: nonNumericRelease.fulfilled,
      }}
      referenceNumber={nonNumericRelease.referenceNumber}
    />
  )
})
